import Footer from "../components/Footer";
import Header from "../components/Header";
import image1 from "../images/FB_IMG_16046691071122362.jpg";
import image2 from "../images/FB_IMG_16046697852096609.jpg";
import image3 from "../images/FB_IMG_16046698142076393.jpg";
import image4 from "../images/FB_IMG_16046698665751719.jpg";
import { Link } from "react-router-dom";
import Product from "../components/Product";
import dream from "../images/dream.png";
import tooth from "../images/tooth.JPG";
import elec from "../images/elec.png";
import qute from "../images/qute.jpg";
import bajaj3 from "../images/bajaj3.jpg";
import maxima from "../images/maxima-z-2.jpg";
import { Bike, Wrench } from "lucide-react";

const Home = () => {
  return (
    <div>
      <Header />

      <section id="banner">
        <div className="container">
          <div className="row">
            <div className="col-sm-6 wow fadeInLeft text-center">
              <span className="notify-badge">NEW</span>

              <img
                src={elec}
                alt="Horra Max 7"
                className="banner-img"
              />
            </div>

            <div className="col-sm-6 px-5">
              <p className="head">JTM Trading</p>

              <p className="head-text">
                We are one of the leading distributors of Bajaj vehicles and
                related products, offering a wide range of reliable and
                innovative solutions including the{" "}
                <b>Electric Max 7</b>, Dream One, Excavator Bucket Tooth and
                MAXIMA-Z. With a strong commitment to quality, reliability,
                and customer satisfaction, we provide dependable mobility and
                equipment solutions for individuals, businesses, and various
                transportation and industrial needs.
              </p>

              <a href="#products" className="head-link">
                More Details
              </a>
            </div>
          </div>
        </div>
      </section>

      <section id="services">
        <div className="container text-center">
          <h2 id="title">SERVICES</h2>

          <div className="row">
            {/* SALES */}
            <div className="col-md-6 wow fadeInUp">
              <div className="service-card">
                <div className="service-icon">
                  <Bike size={48} strokeWidth={2} />
                </div>

                <h3>SALES</h3>

                <p>
                  Visit our store and choose your favorite motorcycle from a
                  variety of options. Our store includes three and four
                  wheelers too.
                </p>
              </div>
            </div>

            {/* SPARE PARTS */}
            <div className="col-md-6 wow fadeInUp">
              <div className="service-card">
                <div className="service-icon">
                  <Wrench size={48} strokeWidth={2} />
                </div>

                <h3>SPARE PARTS</h3>

                <p>
                  Our company also provides a wide range of spare parts for
                  motorcycles, three-wheelers and four-wheelers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="products">
        <div className="container text-center">
          <h2 id="title">PRODUCTS</h2>

          <div className="row">
            <div className="col-lg-4 wow zoomIn">
              <Product
                img={elec}
                text="Horra Max 7"
                link="/products/max7"
              />
            </div>

            <div className="col-lg-4 wow zoomIn">
              <Product
                img={dream}
                text="Dream One"
                link="/products/dream"
              />
            </div>

            <div className="col-lg-4 wow zoomIn">
              <Product
                img={tooth}
                text="Excavator Tip"
                link="/products/tooth"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-lg-4 wow zoomIn">
              <Product
                img={maxima}
                text="Maxima Z"
                link="/products/maxima-z"
              />
            </div>

            <div className="col-lg-4 wow zoomIn">
              <Product
                img={bajaj3}
                text="RE Compact"
                link="/products/re-compact"
              />
            </div>

            <div className="col-lg-4 wow zoomIn">
              <Product
                img={qute}
                text="Qute"
                link="/products/qute"
              />
            </div>
          </div>

          <Link
            type="button"
            className="button-class"
            to="/products"
          >
            <b>VIEW ALL</b>
          </Link>
        </div>
      </section>

      <section id="store">
        <div className="container text-center">
          <h2 id="title">OUR STORE</h2>

          <div className="row">
            <div className="col-md-6 wow zoomIn">
              <img
                src={image1}
                className="store-img bottom-margin"
                alt="JTM Trading store"
              />
            </div>

            <div className="col-md-6 wow zoomIn">
              <img
                src={image2}
                className="store-img bottom-margin"
                alt="JTM Trading store interior"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 wow zoomIn">
              <img
                src={image3}
                className="store-img top-margin"
                alt="JTM Trading showroom"
              />
            </div>

            <div className="col-md-6 wow zoomIn">
              <img
                src={image4}
                className="store-img top-margin"
                alt="JTM Trading showroom"
              />
            </div>
          </div>
        </div>
      </section>

      <section id="address">
        <div className="container address wow fadeInDown">
          <div className="location text-center">
            <h2 id="title">LOCATION</h2>

            <p>
              <i className="fas fa-map-marker-alt"></i>{" "}
              Main Office: Kirkos Shop center C-007 & C-009, Addis Ababa,
              Ethiopia
            </p>

            <p>
              <i className="fas fa-map-marker-alt"></i>{" "}
              Bethel around CBE Bethel Mariam Branch, Addis Ababa, Ethiopia
            </p>
          </div>
        </div>

        <div className="gmap_canvas">
          <iframe
            id="gmap_canvas"
            title="JTM Trading location map"
            src="https://maps.google.com/maps?q=kirkos%20shopping%20center&t=&z=15&ie=UTF8&iwloc=&output=embed"
            frameBorder="0"
            scrolling="no"
            marginHeight="0"
            marginWidth="0"
          ></iframe>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Home;